const data = {
  counterText: 'Slot Terhad!',
  loading: 'Memuatkan',
  next: 'Seterusnya',
  previous: 'Sebelumnya',
  smCounterText: 'Hanya tinggal slot terhad.',
};

export default data;
